import { render, staticRenderFns } from "./MyReward.vue?vue&type=template&id=0847963d&scoped=true&"
import script from "./MyReward.vue?vue&type=script&lang=js&"
export * from "./MyReward.vue?vue&type=script&lang=js&"
import style0 from "./MyReward.vue?vue&type=style&index=0&id=0847963d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0847963d",
  null
  
)

export default component.exports